import { render, staticRenderFns } from "./RankingFranchise.vue?vue&type=template&id=e1254a02&"
import script from "./RankingFranchise.vue?vue&type=script&lang=js&"
export * from "./RankingFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports